<!-- ----------------------------------------------- -->
<template>
  <div id="mapArea">
    <div class="map-header">
      <map-pc-header v-show="isPcMode"></map-pc-header>
      <map-mb-header v-show="!isPcMode"></map-mb-header>
    </div>
    <div v-if="radarNumber == 1" id="kwb-map-view" class="map-map">
      <map-tm-list v-if="showTmList"></map-tm-list>
      <div
        v-show="!isNotPlay"
        :class="!isReady ? 'map-disable' : 'map-disable map-loading'"
      >
        <v-row align="center" justify="center" class="map-disable-child">
          <v-progress-circular
            v-show="isReady"
            indeterminate
            :size="100"
            :width="10"
            justify-center
          ></v-progress-circular>
        </v-row>
      </div>
      <map-base></map-base>
      <map-mb-emergency-info-dlg
        v-if="!isPcMode && showEmergencyInfoDlg"
      ></map-mb-emergency-info-dlg>
      <map-any-info-dlg v-if="showAnyInfoDlg"></map-any-info-dlg>
      <map-emergency-info></map-emergency-info>
      <map-mb-side-menu
        v-if="!isPcMode && showMenu && isNotPlay"
      ></map-mb-side-menu>
      <map-zoom-control v-show="isNotPlay && showMenu"></map-zoom-control>
      <map-setting-panel
        v-show="showSettingPanel && showMenu"
        :key="settingPanelComponentKey"
      ></map-setting-panel>
      <map-area-search v-show="showAreaSearch"></map-area-search>
      <map-calendar v-show="showCalendar"></map-calendar>
      <map-view-group v-show="isPcMode && showViewGroup"></map-view-group>
      <map-mb-view-group
        v-show="!isPcMode && showViewGroup"
      ></map-mb-view-group>
      <map-legend v-show="showLegend"></map-legend>
      <map-tm-info-frame
        v-if="isPcMode && (showInformation || showRiverWarnInfo)"
      ></map-tm-info-frame>
      <map-mb-tm-info-frame
        v-if="!isPcMode && (showInformation || showRiverWarnInfo)"
      ></map-mb-tm-info-frame>
      <map-toast></map-toast>
      <map-past-popup v-show="!isCurrent && isPcMode"></map-past-popup>
      <map-tm-group-toast></map-tm-group-toast>
    </div>

    <div v-if="radarNumber == 4" id="kwb-map-view" class="map-map">
      <map-tm-list v-if="showTmList"></map-tm-list>
      <v-row class="ma-0 map-height">
        <v-col class="pa-0">
          <map-base :mapNum="3" @push="mapPush"></map-base>
        </v-col>
        <v-col class="pa-0">
          <map-base :mapNum="2" @push="mapPush"></map-base>
        </v-col>
      </v-row>
      <v-row class="ma-0 map-height">
        <v-col class="pa-0">
          <map-base :mapNum="1" @push="mapPush"></map-base>
        </v-col>
        <v-col class="pa-0">
          <map-base :mapNum="0" @push="mapPush"></map-base>
        </v-col>
      </v-row>
      <map-setting-panel></map-setting-panel>
      <map-emergency-info-dlg
        v-if="isPcMode && showEmergencyInfoDlg"
      ></map-emergency-info-dlg>
      <map-emergency-info></map-emergency-info>
      <map-area-search v-show="showAreaSearch"></map-area-search>
      <map-calendar v-show="showCalendar"></map-calendar>
      <map-view-group v-show="isPcMode && showViewGroup"></map-view-group>
      <map-mb-view-group
        v-show="!isPcMode && showViewGroup"
      ></map-mb-view-group>
      <map-legend v-show="showLegend"></map-legend>
      <map-zoom-control></map-zoom-control>
      <map-tm-info-frame
        v-if="isPcMode && (showInformation || showRiverWarnInfo)"
      ></map-tm-info-frame>
      <map-mb-tm-info-frame
        v-if="!isPcMode && (showInformation || showRiverWarnInfo)"
      ></map-mb-tm-info-frame>
      <map-toast></map-toast>
      <map-past-popup v-show="!isCurrent && isPcMode"></map-past-popup>
      <map-tm-group-toast></map-tm-group-toast>
    </div>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import "leaflet";
import "leaflet.sync/L.Map.Sync";
import mixin from "../lib/mixin.js";
import MapPcHeader from "./pc/MapHeader";
import MapMbHeader from "./mb/MapHeader";
import MapMbEmergencyInfoDlg from "../components/mb/EmergencyInfoDlg";
import MapAnyInfoDlg from "../components/mb/AnyInfoDlg";
import MapEmergencyInfo from "../components/map/EmergencyInfo";
import MapAreaSearch from "../components/map/AreaSearch";
import MapCalendar from "../components/map/Calendar";
import MapViewGroup from "../components/pc/MapViewGroup";
import MapMbViewGroup from "../components/mb/MapViewGroup";
import MapLegend from "../components/map/Legend";
import MapSettingPanel from "../components/map/SettingPanel";
import MapMbSideMenu from "./mb/SideMenu";
import MapZoomControl from "../components/map/ZoomControl";
import MapTmInfoFrame from "../components/pc/TmInfoFrame";
import MapMbTmInfoFrame from "../components/mb/TmInfoFrame";
import MapToast from "../components/map/Toast";
import MapBase from "../components/map/MapBase.vue";
import WebStorage from "../lib/webStorage.js";
import MapTmList from "../components/map/TmList";
import MapPastPopup from "../components/map/PastPopup";
import MapTmGroupToast from "../components/map/TmGroupToast";
import Util from "../lib/util.js";
import PageLog from "../lib/pageLog.js";

/**
 * 川の防災情報 地図画面
 * Map.vue
 * @author LIS
 */
export default {
  /** タグ名 */
  name: "kwb-map",
  mixins: [mixin],
  /** コンポーネント */
  components: {
    MapPcHeader,
    MapMbHeader,
    MapMbEmergencyInfoDlg,
    MapAnyInfoDlg,
    MapEmergencyInfo,
    MapAreaSearch,
    MapCalendar,
    MapViewGroup,
    MapMbViewGroup,
    MapLegend,
    MapSettingPanel,
    MapMbSideMenu,
    MapZoomControl,
    MapTmInfoFrame,
    MapMbTmInfoFrame,
    MapToast,
    MapBase,
    MapTmList,
    MapPastPopup,
    MapTmGroupToast,
  },
  /** データ部 */
  data: () => ({
    /** 観測日時更新タイマーのインターバルID */
    appDateIntervalId: undefined,
    /** 任意お知らせ取得タイマーのインターバルID */
    anyInfoIntervalId: undefined,
    /** 緊急お知らせ取得タイマーのインターバルID */
    emergencyInfoIntervalId: undefined,
    /** 設定パネル再描画のためのコンポーネントのKey */
    settingPanelComponentKey: 10,
    /** リサイズイベントで高さの変更を判定するために保持 */
    windowInnerHeight: 0,
    /** 4枚表示を同期させるための地図オブジェクトリスト */
    mapObjList: [],
  }),
  /** 初期化部 */
  created() {
    // webストレージが未設定の場合は、初期値を設定する
    this.initWebStrage();
    this.initMap();
  },
  mounted() {
    //タイマー処理
    this.setTimer();
    // 画面サイズ変更イベント
    window.addEventListener("resize", this.handleResize);
    // 画面回転イベント
    window.addEventListener("orientationchange", this.handleResize);
    this.handleResize();

    // 選択中観測所グループをトースト表示
    this.$store.commit("map/setShowTmGroupToast", true);

    if (this.isPcMode) {
      // PCモードの場合のみ、地図画面初期表示時に凡例ダイアログを表示
      this.$store.commit("map/setShowLegend", true);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("orientationchange", this.handleResize);
  },
  /** 算出部 */
  computed: {
    /** メッセージ情報 */
    messageConfig: {
      get() {
        return this.$store.state.app.config.messageConfig;
      },
    },
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
    /** モード */
    isPcMode: {
      get() {
        return this.$store.state.app.mode == "pc";
      },
    },
    /** モバイルメニュー表示状態 */
    showMenu() {
      return this.$store.state.map.showMbSideMenu;
    },
    /** 緊急お知らせダイアログ表示 */
    showEmergencyInfoDlg: {
      get() {
        return this.$store.state.map.showEmergencyInfoDlg;
      },
    },
    /** 任意お知らせダイアログ表示 */
    showAnyInfoDlg: {
      get() {
        return this.$store.state.map.showAnyInfoDlg;
      },
    },
    /** 住所検索ダイアログの表示/非表示 */
    showAreaSearch: {
      get() {
        return this.$store.state.map.showAreaSearch;
      },
    },
    /** 日付入力ダイアログの表示/非表示 */
    showCalendar: {
      get() {
        return this.$store.state.map.showCalendar;
      },
    },
    /** 表示グループ設定ダイアログの表示/非表示 */
    showViewGroup: {
      get() {
        return this.$store.state.map.showViewGroup;
      },
    },
    /** 地図凡例ダイアログの表示/非表示 */
    showLegend: {
      get() {
        return this.$store.state.map.showLegend;
      },
    },
    /** お知らせダイアログの表示/非表示 */
    showInformation: {
      get() {
        return this.$store.state.map.showInformation;
      },
    },
    /** 河川予警報ダイアログの表示/非表示 */
    showRiverWarnInfo: {
      get() {
        return this.$store.state.map.showRiverWarnInfo;
      },
    },
    /** レーダ雨量の種類 [xrain:XRAIN, cband:Cバンドレーダ] */
    radarType: {
      get() {
        return this.$store.state.radar.radarType;
      },
    },
    /** 河川予警報の座標を取得 */
    showRwGeoJson: {
      get() {
        return this.$store.state.RiverWarn.rwGeoJson;
      },
    },
    /** 現在位置情報取得エラーフラグ */
    getCurrentLocationErrorFlag: {
      get() {
        return this.$store.state.map.currentLocationErrorFlag;
      },
    },
    /** 地図の枚数 [1枚, 4枚]の取得 */
    radarNumber: {
      get() {
        return this.$store.state.radar.radarNumber;
      },
    },
    /** 登録地点読み込み日時の取得 */
    editWebStorageDate: {
      get() {
        return this.$store.state.map.editWebStorageDate;
      },
    },
    /** 履歴動画再生状態 */
    historyPlayStatus: {
      get() {
        return this.$store.state.radar.historyPlayStatus;
      },
    },
    /** 履歴動画再生中状態 */
    isPlay: {
      get() {
        return this.$store.getters["radar/isPlay"];
      },
    },
    /** 履歴動画準備中状態 */
    isReady: {
      get() {
        return this.$store.getters["radar/isReady"];
      },
    },
    /** 履歴MAP準備中状態 */
    isReadyMap: {
      get() {
        return this.$store.getters["radar/isReadyMap"];
      },
    },
    /** 履歴動画再生/準備中以外状態 */
    isNotPlay: {
      get() {
        return this.$store.getters["radar/isNotPlay"];
      },
    },
    /** 履歴動画準備状態全体(レーダ地図表示、観測所、予警報) */
    historyPlayPrepStatusAll: {
      get() {
        return {
          mapStatus: this.$store.state.map.historyPlayPrepStatus,
          tmStatus: this.$store.state.Telemeter.historyPlayPrepStatus,
          rwStatus: this.$store.state.RiverWarn.historyPlayPrepStatus,
        };
      },
    },
    /** 周辺観測所一覧 */
    tmPointDatas: {
      get() {
        return this.$store.state.Telemeter.tmPointDatas;
      },
    },
    /** 重複表示観測所一覧ダイアログの表示/非表示 */
    showTmList: {
      get() {
        return this.$store.state.map.showTmList;
      },
    },
    /** 表示コンテンツ */
    content: {
      get() {
        return this.$store.state.app.content;
      },
    },
    /** 観測日時 [true:最新, false:履歴] */
    isCurrent: {
      get() {
        return this.$store.state.app.isCurrent;
      },
    },
    /** 設定パネル表示制御 */
    showSettingPanel: {
      get() {
        if (
          (this.content == "VcPoint" &&
            this.$store.state.map.editLocationMode != 0) ||
          this.content == "VcDefault" ||
          this.content == "VcCustom"
        ) {
          return false;
        }
        return true;
      },
    },
    /** レーダ画像レイヤー表示制御 */
    showRadar: {
      get() {
        // ダム放流通知選択時は非表示
        if (
          this.content === "Riverwarn" &&
          this.$store.state.RiverWarn.selectedWarnType === 30
        ) {
          return false;
        }
        // 表示コンテンツが「浸水想定」または「表示設定」の場合非表示
        if (
          this.content === "Inundation" ||
          this.content === "VcPoint" ||
          this.content === "VcDefault" ||
          this.content === "VcCustom"
        ) {
          return false;
        }

        // その他の場合は表示設定に従う
        return this.$store.state.map.viewRadar;
      },
    },
    /** 観測日時 */
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    /** 地図タイル(浸水想定)表示 */
    showMapInundation: {
      get() {
        return this.$store.state.map.showMapInundation;
      },
    },
  },
  methods: {
    /** 初期化処理 */
    initMap() {
      // 地図の初期値設定
      this.$store.commit("map/init", {
        zoom: this.isPcMode
          ? this.mapConfig.initZoom
          : this.mapConfig.initZoomMb,
        center: this.mapConfig.initCenter,
        minZoom: this.mapConfig.minZoom,
        maxZoom: this.mapConfig.maxZoom,
        boundsArea: this.mapConfig.boundsArea,
        mapType: this.mapConfig.initMapType,
        viewGroup: this.mapConfig.initViewGroup,
        viewRadar: this.mapConfig.initViewRadar,
        viewRiverWarn: this.mapConfig.initViewRiverWarn,
        viewRiver: this.mapConfig.initViewRiver,
        viewPoint: this.mapConfig.initViewPoint,
        viewContents: this.mapConfig.initViewContents,
      });

      // 初期表示設定反映
      // 表示位置
      if (
        this.$route.query["pidx"] !== 0 &&
        this.$route.query["pidx"] !== 1 &&
        this.$route.query["pidx"] !== 2 &&
        this.$route.query["pidx"] !== 3 &&
        this.$route.query["pidx"] !== 4
      ) {
        if (
          WebStorage.getDefaultInfo().point1 &&
          WebStorage.getPoint1Info() &&
          WebStorage.getPoint1Info().center
        ) {
          this.$store.commit(
            "map/setCenter",
            WebStorage.getPoint1Info().center
          );
          this.$store.commit("map/setViewZoom", this.mapConfig.zoomPoint);
        } else if (
          WebStorage.getDefaultInfo().point2 &&
          WebStorage.getPoint2Info() &&
          WebStorage.getPoint2Info().center
        ) {
          this.$store.commit(
            "map/setCenter",
            WebStorage.getPoint2Info().center
          );
          this.$store.commit("map/setViewZoom", this.mapConfig.zoomPoint);
        } else if (
          WebStorage.getDefaultInfo().point3 &&
          WebStorage.getPoint3Info() &&
          WebStorage.getPoint3Info().center
        ) {
          this.$store.commit(
            "map/setCenter",
            WebStorage.getPoint3Info().center
          );
          this.$store.commit("map/setViewZoom", this.mapConfig.zoomPoint);
        } else if (
          WebStorage.getDefaultInfo().point4 &&
          WebStorage.getPoint4Info() &&
          WebStorage.getPoint4Info().center
        ) {
          this.$store.commit(
            "map/setCenter",
            WebStorage.getPoint4Info().center
          );
          this.$store.commit("map/setViewZoom", this.mapConfig.zoomPoint);
        } else if (
          WebStorage.getDefaultInfo().point5 &&
          WebStorage.getPoint5Info() &&
          WebStorage.getPoint5Info().center
        ) {
          this.$store.commit(
            "map/setCenter",
            WebStorage.getPoint5Info().center
          );
          this.$store.commit("map/setViewZoom", this.mapConfig.zoomPoint);
        }
      }

      // 表示設定
      this.setViewGroup();

      // 4枚表示の解除
      this.$store.commit("radar/setNumber", 1);

      // 緊急お知らせ情報取得
      this.$store.dispatch("info/getEmergencyInfo");
      // 任意お知らせ情報取得
      this.$store.dispatch("info/getAnyInfo");
      // webストレージ編集日時設定
      this.$store.commit("map/setEditWebStorageDate", Util.toDate());
      // url解析
      if (
        location.pathname !== "/kawabou/pc/rp" &&
        location.pathname !== "/kawabou/mb/rp"
      ) {
        // 登録地点画面以外の場合にパラメータを反映する
        const urlZoom = this.$route.query["zm"];
        const urlClat = this.$route.query["clat"];
        const urlClon = this.$route.query["clon"];
        if (urlClat != undefined && urlClon != undefined) {
          this.$store.commit("map/setCenter", [
            parseFloat(urlClat),
            parseFloat(urlClon),
          ]);
        }
        if (urlZoom != undefined) {
          this.$store.commit("map/setViewZoom", parseInt(urlZoom));
        }
      }
      // 表示設定
      const info = WebStorage.getDefaultInfo();
      // 地図種別
      const urlMapType = this.$route.query["mapType"];
      if (urlMapType != undefined) {
        this.$store.commit("map/setMapType", parseInt(urlMapType));
      } else if (info.mapType != undefined) {
        this.$store.commit("map/setMapType", info.mapType);
      }
      // 表示観測所
      const urlViewGrpStg = this.$route.query["viewGrpStg"];
      if (urlViewGrpStg != undefined) {
        this.$store.commit("map/setViewGroup", parseInt(urlViewGrpStg));
      }
      // レーダ雨量
      const urlViewRd = this.$route.query["viewRd"];
      if (urlViewRd != undefined) {
        this.$store.commit("map/setViewRadar", urlViewRd == 1 ? true : false);
      } else if (info.viewRd != undefined) {
        this.$store.commit("map/setViewRadar", info.viewRd);
      }
      // 河川予警報
      const urlViewRW = this.$route.query["viewRW"];
      if (urlViewRW != undefined) {
        this.$store.commit(
          "map/setViewRiverWarn",
          urlViewRW == 1 ? true : false
        );
      } else if (info.viewRw != undefined) {
        this.$store.commit("map/setViewRiverWarn", info.viewRw);
      }
      // 河川
      const urlViewRiver = this.$route.query["viewRiver"];
      if (urlViewRiver != undefined) {
        this.$store.commit(
          "map/setViewRiver",
          urlViewRiver == 1 ? true : false
        );
      } else if (info.viewRvrln != undefined) {
        this.$store.commit("map/setViewRiver", info.viewRvrln);
      }
      // 登録地点
      const urlViewPoint = this.$route.query["viewPoint"];
      if (urlViewPoint != undefined) {
        this.$store.commit(
          "map/setViewPoint",
          urlViewPoint == 1 ? true : false
        );
      } else if (info.viewRp != undefined) {
        this.$store.commit("map/setViewPoint", info.viewRp);
      }
      // 表示コンテンツ設定
      const urlViewContents = this.$route.query["viewContents"];
      if (urlViewContents != undefined) {
        this.$store.commit("map/setViewContents", parseInt(urlViewContents));
      }

      // urlパラメータ設定
      this.routerMapMove();
      this.routerMapSetting();

      // 都道府県判定リスト、市町村判定リスト取得
      this.$store.dispatch("map/getPrefTownJadgeList");

      // 地図上のダイアログを全て閉じる
      this.$store.commit("map/dialogAllClose");

      /* XRAIN定量範囲、Cバンド定量範囲のラインを取得する */
      if (this.mapConfig.showRadarLine) {
        this.$store.dispatch("radar/getRadarLine");
      }
      // レーダ観測日時を更新する
      this.$store.dispatch("radar/requestRadarDate", {
        time: this.appTime,
        current: this.$store.state.app.isCurrent,
      });

      // アクセスログ出力
      PageLog.log({
        page_log: "map",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
    },
    /** webストレージの初期設定 */
    initWebStrage() {
      // 初期表示設定
      if (
        !WebStorage.getDefaultInfo() ||
        !Object.keys(WebStorage.getDefaultInfo()).length
      ) {
        let defaultInfo = {
          point1: false,
          point2: false,
          point3: false,
          point4: false,
          point5: false,
          pointDefault: true,
          disp1: false,
          disp2: false,
          disp3: false,
          disp4: false,
          disp5: false,
          dispCustom: false,
          general: true,
          flood: false,
          mapType: 0,
          viewRd: true,
          viewRw: true,
          viewRvrln: true,
          viewRp: true,
        };
        // 表示観測所選択は設定ファイルの初期値に合わせて設定
        switch (this.mapConfig.initViewGroup) {
          case 0:
            defaultInfo.disp1 = true;
            break;
          case 1:
            defaultInfo.disp2 = true;
            break;
          case 2:
            defaultInfo.disp3 = true;
            break;
          case 3:
            defaultInfo.disp4 = true;
            break;
          case 4:
            defaultInfo.disp5 = true;
            break;
          case 5:
            defaultInfo.dispCustom = true;
            break;
        }
        WebStorage.setDefaultInfo(defaultInfo);
      }
      // カスタマイズ設定
      if (
        !WebStorage.getCustomInfo() ||
        !Object.keys(WebStorage.getCustomInfo()).length
      ) {
        WebStorage.setCustomInfo({
          stage: false,
          dam: false,
          rain: false,
          cctv: false,
          scam: false,
          wtrQual: false,
          coast: false,
          snow: false,
          swin: false,
          fldfr: false,
          damdsch: false,
          fldctl: false,
          // 表示開始ズームレベル
          stageZmLvl: this.mapConfig.zoomTmStg,
          swinZmLvl: this.mapConfig.zoomTmSwstg,
          damZmLvl: this.mapConfig.zoomTmDam,
          rainZmLvl: this.mapConfig.zoomTmRn,
          cctvZmLvl: this.mapConfig.zoomTmCctv,
          scamZmLvl: this.mapConfig.zoomTmScam,
          wtrQualZmLvl: this.mapConfig.zoomTmQwtr,
          coastZmLvl: this.mapConfig.zoomTmCoast,
          snowZmLvl: this.mapConfig.zoomTmSnw,
          // 基準観測所のみ適用
          baseObsOnly: false,
        });
      } else {
        let customInfo = WebStorage.getCustomInfo();
        WebStorage.setCustomInfo({
          stage: customInfo.stage != undefined ? customInfo.stage : false,
          dam: customInfo.dam != undefined ? customInfo.dam : false,
          rain: customInfo.rain != undefined ? customInfo.rain : false,
          cctv: customInfo.cctv != undefined ? customInfo.cctv : false,
          scam: customInfo.scam != undefined ? customInfo.scam : false,
          wtrQual: customInfo.wtrQual != undefined ? customInfo.wtrQual : false,
          coast: customInfo.coast != undefined ? customInfo.coast : false,
          snow: customInfo.snow != undefined ? customInfo.snow : false,
          swin: customInfo.swin != undefined ? customInfo.swin : false,
          fldfr: customInfo.fldfr != undefined ? customInfo.fldfr : false,
          damdsch: customInfo.damdsch != undefined ? customInfo.damdsch : false,
          fldctl: customInfo.fldctl != undefined ? customInfo.fldctl : false,
          // 表示開始ズームレベル
          stageZmLvl:
            customInfo.stageZmLvl != undefined
              ? customInfo.stageZmLvl
              : this.mapConfig.zoomTmStg,
          swinZmLvl:
            customInfo.swinZmLvl != undefined
              ? customInfo.swinZmLvl
              : this.mapConfig.zoomTmSwstg,
          damZmLvl:
            customInfo.damZmLvl != undefined
              ? customInfo.damZmLvl
              : this.mapConfig.zoomTmDam,
          rainZmLvl:
            customInfo.rainZmLvl != undefined
              ? customInfo.rainZmLvl
              : this.mapConfig.zoomTmRn,
          cctvZmLvl:
            customInfo.cctvZmLvl != undefined
              ? customInfo.cctvZmLvl
              : this.mapConfig.zoomTmCctv,
          scamZmLvl:
            customInfo.scamZmLvl != undefined
              ? customInfo.scamZmLvl
              : this.mapConfig.zoomTmScam,
          wtrQualZmLvl:
            customInfo.wtrQualZmLvl != undefined
              ? customInfo.wtrQualZmLvl
              : this.mapConfig.zoomTmQwtr,
          coastZmLvl:
            customInfo.coastZmLvl != undefined
              ? customInfo.coastZmLvl
              : this.mapConfig.zoomTmCoast,
          snowZmLvl:
            customInfo.snowZmLvl != undefined
              ? customInfo.snowZmLvl
              : this.mapConfig.zoomTmSnw,
          // 基準観測所のみ適用
          baseObsOnly:
            customInfo.baseObsOnly != undefined
              ? customInfo.baseObsOnly
              : false,
        });
      }
    },
    /** タイマー処理のセット */
    setTimer() {
      // 観測日時の更新
      // 履歴表示の場合は、タイマーをセットしない
      if (this.isCurrent) {
        this.appDateIntervalId = setInterval(
          function () {
            if (this.$store.state.map.showCalendar === false) {
              this.$store.commit("app/renewTime");
            }
          }.bind(this),
          this.$store.state.app.config.appConfig.timer.updateAppTime
        );
      }
      // 任意お知らせの取得
      this.anyInfoIntervalId = setInterval(
        function () {
          this.$store.dispatch("info/getAnyInfo");
        }.bind(this),
        this.$store.state.app.config.appConfig.timer.updateAnyInfo
      );
      // 緊急お知らせの取得
      this.emergencyInfoIntervalId = setInterval(
        function () {
          this.$store.dispatch("info/getEmergencyInfo");
        }.bind(this),
        this.$store.state.app.config.appConfig.timer.updateEmergencyInfo
      );
    },
    /** タイマー処理のクリア */
    clearTimer() {
      if (this.appDateIntervalId) {
        clearInterval(this.appDateIntervalId);
      }
      if (this.anyInfoIntervalId) {
        clearInterval(this.anyInfoIntervalId);
      }
      if (this.emergencyInfoIntervalId) {
        clearInterval(this.emergencyInfoIntervalId);
      }
      // インターバルIDをクリア
      this.appDateIntervalId = undefined;
      this.anyInfoIntervalId = undefined;
      this.emergencyInfoIntervalId = undefined;
    },
    /** WebStorageの表示設定をストアに反映 */
    setViewGroup() {
      if (WebStorage.getDefaultInfo().disp1) {
        this.$store.commit("map/setViewGroup", 0);
      } else if (WebStorage.getDefaultInfo().disp2) {
        this.$store.commit("map/setViewGroup", 1);
      } else if (WebStorage.getDefaultInfo().disp3) {
        this.$store.commit("map/setViewGroup", 2);
      } else if (WebStorage.getDefaultInfo().disp4) {
        this.$store.commit("map/setViewGroup", 3);
      } else if (WebStorage.getDefaultInfo().disp5) {
        this.$store.commit("map/setViewGroup", 4);
      } else if (WebStorage.getDefaultInfo().dispCustom) {
        this.$store.commit("map/setViewGroup", 5);
      }
    },
    /** 画面サイズ変更時処理 */
    handleResize() {
      this.$log.debug("[Map.vue] handleResize()");
      // 高さが変わっていなければ処理しない
      if (this.windowInnerHeight == window.innerHeight) {
        return;
      }
      // 高さを控えておく
      this.windowInnerHeight = window.innerHeight;
      // モバイルのアドレスバー、フッダーメニュー領域の増減に対応
      // vueが生成するclass,window.innerHeightのmin-heightを書き換え
      // リサイズ完了前に高さを取得してしまうことを考慮し、タイマーで動作
      setTimeout(function () {
        let vApplicationWrap = document.getElementsByClassName(
          "v-application--wrap"
        );
        vApplicationWrap[0].style.minHeight = window.innerHeight + "px";
      }, 300);
      // 中心位置がずれるため、地図を再描画
      // 高さ設定前に再描画しないよう、さらにタイマーで動作
      setTimeout(this.$store.commit, 400, "map/mapRedraw");
    },
    /** 4枚表示同期のための地図オブジェクトリストを追加 */
    mapPush(mapObjcet) {
      this.mapObjList.push(mapObjcet);
    },
    /** 4枚表示同期 */
    syncMap() {
      this.mapObjList[0].sync(this.mapObjList[1], { syncCursor: false });
      this.mapObjList[0].sync(this.mapObjList[2], { syncCursor: false });
      this.mapObjList[0].sync(this.mapObjList[3], { syncCursor: false });
      this.mapObjList[1].sync(this.mapObjList[0], { syncCursor: false });
      this.mapObjList[1].sync(this.mapObjList[2], { syncCursor: false });
      this.mapObjList[1].sync(this.mapObjList[3], { syncCursor: false });
      this.mapObjList[2].sync(this.mapObjList[0], { syncCursor: false });
      this.mapObjList[2].sync(this.mapObjList[1], { syncCursor: false });
      this.mapObjList[2].sync(this.mapObjList[3], { syncCursor: false });
      this.mapObjList[3].sync(this.mapObjList[0], { syncCursor: false });
      this.mapObjList[3].sync(this.mapObjList[1], { syncCursor: false });
      this.mapObjList[3].sync(this.mapObjList[2], { syncCursor: false });
    },
  },
  watch: {
    /** 表示モードが変化した場合にトースト表示する */
    isPcMode() {
      // 中心位置がずれるため、地図を再描画
      this.$store.commit("map/mapRedraw");
      // FireFoxでツールチップが消えない問題の対策として、設定パネルを再描画
      this.settingPanelComponentKey++;
      // 地図上のダイアログを全て閉じる
      this.$store.commit("map/dialogAllClose");

      if (this.isPcMode) {
        this.$store.commit("map/setShowToast", {
          status: true,
          message: this.messageConfig.changePCMode,
        });
      } else {
        this.$store.commit("map/setShowToast", {
          status: true,
          message: this.messageConfig.changeMobileMode,
        });
      }
    },
    /** レーダモードが変化した場合にトースト表示する */
    radarType() {
      if (this.radarType === "xrain") {
        this.$store.commit("map/setShowToast", {
          status: true,
          message: this.messageConfig.changeXRain,
        });
      } else {
        this.$store.commit("map/setShowToast", {
          status: true,
          message: this.messageConfig.changeCBand,
        });
      }
      // 観測日時の更新
      if (!this.isCurrent) {
        // 過去日時指定の場合のみ、最新観測日時を考慮した最も近い過去の日時を設定
        let NewDate = null;
        if (this.radarType === "xrain") {
          NewDate = Util.toDate(this.$store.state.radar.radarNewXrainDate);
        } else {
          NewDate = Util.toDate(this.$store.state.radar.radarNewCbandDate);
        }
        const roundDate = Util.roundMinutes(
          this.appTime,
          this.$store.state.app.config.appConfig.keepDaysJsonFiles,
          NewDate
        );
        this.$store.commit("app/setTime", roundDate);
      }
    },
    /** モバイルモードで現在位置取得エラーが起きた場合にトースト表示する */
    getCurrentLocationErrorFlag() {
      /** トースト表示の内容判定 */
      if (this.getCurrentLocationErrorFlag == true) {
        /** 表示モード判定 */
        if (!this.isPcMode) {
          this.$store.commit("map/setShowToast", {
            status: true,
            message: this.messageConfig.currentLocationError,
          });
        }
      }
    },
    /** 登録地点読み込み日時の変更を検知し、登録地点の情報を取得する */
    editWebStorageDate() {
      this.$store.dispatch("map/getRegistrationPointInfo");
      // 表示設定に反映
      if (this.content === "VcDefault") {
        this.setViewGroup();
      }
    },
    /** 周辺観測所が更新された場合に、webストレージへの書き込み行う */
    tmPointDatas() {
      switch (this.tmPointDatas.pointIndex) {
        case 0:
          WebStorage.setPoint1Info(this.tmPointDatas);
          break;
        case 1:
          WebStorage.setPoint2Info(this.tmPointDatas);
          break;
        case 2:
          WebStorage.setPoint3Info(this.tmPointDatas);
          break;
        case 3:
          WebStorage.setPoint4Info(this.tmPointDatas);
          break;
        case 4:
          WebStorage.setPoint5Info(this.tmPointDatas);
          break;
      }
      // webストレージ編集日時を更新
      this.$store.commit("map/setEditWebStorageDate", Util.toDate());
      // 登録中フラグを0にする
      this.$store.commit("map/setEditFlag", 0);
      // リスク収集フラグを0にする
      this.$store.commit("viewConfig/setRiskFlg", 0);
    },
    /** 表示コンテンツの監視 */
    content: function (afterContent, beforeContent) {
      // タイマー処理のクリア
      this.clearTimer();

      // 浸水想定/レーダ切替 トースト表示
      if (afterContent == "Inundation") {
        this.$store.commit("map/setShowToast", {
          status: true,
          message: this.messageConfig.changeInundation,
        });
      } else if (beforeContent == "Inundation") {
        this.$store.commit("map/setShowToast", {
          status: true,
          message: this.messageConfig.changeRadar,
        });
      }

      // レーダ画面を表示した時
      if (afterContent == "Radar") {
        // アクセスログ出力
        // カレント表示の場合は日付更新によるログ出力が動作するためここでは出力しない
        if (!this.$store.state.app.isCurrent) {
          PageLog.log({
            page_log: "radar",
            lat: this.$store.state.map.center[0],
            lon: this.$store.state.map.center[1],
            zm: this.$store.state.map.zoom,
            rader_sb: this.$store.state.radar.radarType,
            device_sb: this.$store.state.app.mode,
            fc_flg: this.$store.getters["app/isFldCtl"],
          });
        }
        this.$store.dispatch("radar/requestRadarDate", {
          time: this.$store.state.app.appTime,
          current: this.$store.state.app.isCurrent,
        });
      }

      // 予警報詳細画面から離れた場合の処理
      if (beforeContent == "Riverwarn" || beforeContent == "Radar") {
        // モバイルモードの場合はダイアログ排他表示制御の都合で、カレンダー表示操作を行った際は処理しない
        if (
          this.$store.state.app.mode == "pc" ||
          (this.$store.state.app.mode == "mb" &&
            !this.$store.state.map.showCalendar)
        ) {
          // カレントモードの状態で予警報詳細画面から離れた場合
          if (this.$store.state.app.retentionCurrent) {
            // 観測日時を最新日時に更新する
            this.$store.commit("app/renewTime");
          }
          // 履歴モードの状態で予警報詳細画面から離れた場合
          else {
            // 観測日時を保持した過去日時に更新する
            this.$store.commit(
              "app/setTime",
              this.$store.state.app.retentionTime
            );
          }
        }
      } else if (afterContent != "") {
        // 観測日時の更新
        // 履歴表示の場合は更新しない
        if (this.isCurrent) {
          this.$store.commit("app/renewTime");
        }
      }

      // 予警報詳細画面、レーダ雨量画面を表示した場合の処理
      if (afterContent == "Riverwarn" || afterContent == "Radar") {
        // 画面遷移時の保持日時を更新
        this.$store.commit("app/setRetentionTime", {
          time: this.appTime,
          flag: this.isCurrent,
        });
      }

      // モバイルモードで画面を開いた際には、地図上のダイアログを全て閉じる
      if (beforeContent == "" && this.$store.state.app.mode == "mb") {
        this.$store.commit("map/dialogAllClose");
      }

      // 地図選択中観測所,予警報をクリア
      this.$store.commit("map/setSelectTm", null);
      this.$store.commit("map/setSelectRw", null);

      // 4枚表示の解除
      // レーダ画面に遷移した際は更新しない(初期表示がレーダ画面の場合を考慮)
      if (afterContent != "Radar") {
        this.$store.commit("radar/setNumber", 1);
      }

      // 緊急お知らせ情報取得
      this.$store.dispatch("info/getEmergencyInfo");
      // 任意お知らせ情報取得
      this.$store.dispatch("info/getAnyInfo");

      // タイマー処理のセット
      this.setTimer();
    },
    /** 観測日時 [true:最新, false:履歴]の監視 */
    isCurrent() {
      // 最新表示の場合は観測日時更新タイマーをセットする
      if (this.isCurrent) {
        if (!this.appDateIntervalId) {
          this.appDateIntervalId = setInterval(
            function () {
              this.$store.commit("app/renewTime");
            }.bind(this),
            this.$store.state.app.config.appConfig.timer.updateAppTime
          );
        }
      }
      // 履歴表示の場合は観測日時更新タイマーをクリアする
      else {
        if (this.appDateIntervalId) {
          clearInterval(this.appDateIntervalId);
        }
        // インターバルIDをクリア
        this.appDateIntervalId = undefined;
      }
    },
    /** 履歴動画再生状態(レーダ)の監視 */
    historyPlayStatus() {
      // 「地図準備中」の場合
      if (this.isReadyMap) {
        // 河川予警報レイヤー表示の場合は履歴動画再生状態を「準備状態」に、非表示の場合は「再生可状態」に更新
        if (this.$store.state.map.viewRiverWarn) {
          this.$store.commit("RiverWarn/setHistoryPlayPrepStatus", "ready");
        } else {
          this.$store.commit("RiverWarn/setHistoryPlayPrepStatus", "playable");
        }
        if (!this.showRadar) {
          // レーダ画像レイヤーが非アクティブの場合は、レーダ画像の履歴動画再生状態を「再生可状態」に更新
          this.$store.commit("map/setHistoryPlayPrepStatus", "playable");
        }
        // レーダ画像レイヤーがアクティブの場合は、レーダ画像レイヤーに制御を委ねるため更新しない
        // 観測所レイヤーの履歴動画再生状態は、観測所レイヤーに制御を委ねるため更新しない
      }
    },
    /** 履歴動画再生状態全体(レーダ、観測所、予警報)の監視 */
    historyPlayPrepStatusAll() {
      if (this.isReadyMap) {
        // すべてのステータスが「再生可状態」となっている場合に、「再生状態」に更新
        if (
          this.historyPlayPrepStatusAll.mapStatus === "playable" &&
          this.historyPlayPrepStatusAll.tmStatus === "playable" &&
          this.historyPlayPrepStatusAll.rwStatus === "playable"
        ) {
          this.$store.commit("radar/setHistoryPlayStatus", "play");
        }
      }
    },
    /** 住所検索ダイアログ表示 */
    showAreaSearch() {
      // 非表示になったとき、検索中状態であれば検索前状態に戻す
      if (
        !this.showAreaSearch &&
        this.$store.state.map.addressSearchStatus === 2
      ) {
        this.$store.commit("map/setAddressSearchStatus", 1);
      }
    },
    /** 履歴動画再生/準備中以外状態 */
    isNotPlay() {
      if (!this.isNotPlay) {
        // 履歴動画再生/準備中状態に変化した場合、観測日時更新タイマーをクリアする
        clearInterval(this.appDateIntervalId);
        this.appDateIntervalId = undefined;
        // 各ポップアップ表示を閉じる
        this.$store.commit("map/setShowAreaSearch", false);
        this.$store.commit("map/setShowCalendar", false);
        this.$store.commit("map/setShowViewGroup", false);
        this.$store.commit("map/setShowEmergencyInfoDlg", false);
      }
    },
    /** 設定パネル表示 */
    showSettingPanel() {
      if (!this.showSettingPanel) {
        this.$store.commit("map/setShowLegend", false);
        this.$store.commit("map/setShowViewGroup", false);
      }
    },
    /** 観測日時 */
    appTime() {
      if (this.$store.getters["radar/isNone"]) {
        // レーダ観測日時を更新する

        // アクセスログ出力
        // 画面表示中のみログ出力
        if (this.$store.state.app.content == "Radar") {
          PageLog.log({
            page_log: "radar",
            lat: this.$store.state.map.center[0],
            lon: this.$store.state.map.center[1],
            zm: this.$store.state.map.zoom,
            rader_sb: this.$store.state.radar.radarType,
            device_sb: this.$store.state.app.mode,
            fc_flg: this.$store.getters["app/isFldCtl"],
          });
        }
        this.$store.dispatch("radar/requestRadarDate", {
          time: this.appTime,
          current: this.$store.state.app.isCurrent,
        });
      }
    },
    /** 地図タイル(浸水想定)表示 */
    showMapInundation() {
      // 浸水想定/レーダ切替 トースト表示
      // 登録地点情報画面での切替に対応
      if (this.content == "RegistPoint") {
        if (this.showMapInundation) {
          this.$store.commit("map/setShowToast", {
            status: true,
            message: this.messageConfig.changeInundation,
          });
        } else {
          this.$store.commit("map/setShowToast", {
            status: true,
            message: this.messageConfig.changeRadar,
          });
        }
      }
    },
    /** 地図オブジェクトリストの更新 */
    mapObjList(map) {
      // 4枚になったときに同期させる
      if (map.length >= 4) {
        this.syncMap();
      }
    },
    /** 地図枚数更新 */
    radarNumber(num) {
      // 1枚表示になったら地図オブジェクトリストをクリア
      if (num == 1) {
        this.mapObjList = [];
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
#mapArea {
  z-index: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .map-header {
    z-index: 1;
    width: 100%;
  }
  .map-map {
    z-index: 1;
    position: relative;
    flex: 1;

    .map-height {
      height: 50%;
    }
  }
  .map-disable {
    position: absolute;
    z-index: 3040;
    width: 100%;
    height: 100%;
  }
  .map-loading {
    background-color: dimgray;
    opacity: 0.5;
    .map-disable-child {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
